import EditAdministratorForm from './EditAdministratorForm';

export default EditAdministratorForm;
